// import logo from './logo.svg';
import "./App.css";
import Main_page from "./Compounent/Main_page/Main_page";
import Login from "./Compounent/Login/Login";
import Register from "./Compounent/Register/Register";
import Reset_password from "./Compounent/Reset_password/Reset_password";
import Verify from "./Compounent/Verify/Verify";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Navbar from "./Compounent/Navbar/Navbar";
import Payment_method from "./Compounent/Payment_method/Payment_method";
import Points_user from "./Compounent/Points_user/Points_user";
import Admin_page1 from "./Compounent/Admin_page1/Admin_page1";
import Driwer_admin from "./Compounent/Driwer_admin/Driwer_admin";
import { Provider, useSelector } from "react-redux";
import Protected_routing from "./Compounent/Protected_routing/Protected_routing";

function App() {
  const { isAuthenticatin } = useSelector((state) => state.connect);
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />

        <Routes>
          <Route exact path="/" element={<Login />} />
          <Route exact path="/Register" element={<Register />} />
          <Route exact path="/Reset_password" element={<Reset_password />} />
          <Route exact path="/Verify" element={<Verify />} />
          <Route
            element={<Protected_routing isAuthenticatin={isAuthenticatin} />}
          >
            <Route exact path="/Main_page" element={<Main_page />} />

            <Route exact path="/Payment_method" element={<Payment_method />} />
            <Route exact path="/Points_user" element={<Points_user />} />
          </Route>
        </Routes>

        {/* <Admin_page1/> */}

        {/* <Driwer_admin/> */}
      </BrowserRouter>
    </div>
  );
}

export default App;
